import { render, staticRenderFns } from "./invite-user-overlay.vue?vue&type=template&id=5d6576b4"
import script from "./invite-user-overlay.vue?vue&type=script&lang=js"
export * from "./invite-user-overlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports